// extracted by mini-css-extract-plugin
export default {"background-$(backgroundColorBg)":"a12c_","background-$(backgroundColor)":"b12c_","wrapper":"c12c_","hintWrapper":"d12c_","hintHidden":"e12c_"};